"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetDefault = GetDefault;

var _truncate = _interopRequireDefault(require("lodash/truncate"));

function GetDefault(params) {
  var processedVal = params.colDef.maxCharLength ? (0, _truncate["default"])(params.data[params.colDef.name], {
    length: params.colDef.maxCharLength + 3
  }) : params.data[params.colDef.name];
  var formattedVal = params.colDef.formatter ? params.colDef.formatter(processedVal, params.data) : processedVal;

  var returnVal = (params.colDef.render || function (val) {
    return val;
  })(formattedVal);

  return returnVal || null;
}